import { render, staticRenderFns } from "./WellManagement.vue?vue&type=template&id=03ff5f9b&scoped=true"
import script from "./WellManagement.vue?vue&type=script&lang=js"
export * from "./WellManagement.vue?vue&type=script&lang=js"
import style0 from "./WellManagement.vue?vue&type=style&index=0&id=03ff5f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ff5f9b",
  null
  
)

export default component.exports